import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { LocationConsentService } from 'src/app/services/location/location-consent.service';
import { IconModule } from 'src/app/shared/icon/icon.module';

/**
 * Termo de uso de localização em segundo plano.
 *
 * Renderizado uma única vez em app.component.html e controlado pelos signals do
 * LocationConsentService — mesmo padrão do lc-modal-confirmation. Por ficar na
 * raiz do app, aparece sobre qualquer tela.
 *
 * Sem botão de fechar e sem clique no backdrop de propósito: a saída é sempre
 * uma escolha explícita, porque as duas respostas são registradas no banco.
 */
@Component({
    selector: 'lc-location-disclosure',
    templateUrl: './location-disclosure.component.html',
    standalone: true,
    imports: [CommonModule, IconModule],
})
export class LocationDisclosureComponent {
    private readonly consentService = inject(LocationConsentService);

    /**
     * Política de privacidade completa.
     *
     * Precisa ser a MESMA URL informada na ficha do app no Play Console — o
     * revisor compara as duas.
     */
    readonly politicaPrivacidadeUrl = 'https://infrasegseguranca.com.br/politica-de-privacidade-infraseg';

    readonly aberto = this.consentService.aberto;

    /** 'geral' fora da ronda, 'ronda' ao entrar na tela de ronda. */
    readonly contexto = this.consentService.contexto;

    /** Trava os botões durante as chamadas de rede, evitando duplo registro. */
    private readonly processando = signal<boolean>(false);
    readonly ocupado = this.processando.asReadonly();

    async aceitar(): Promise<void> {
        if (this.processando()) return;

        this.processando.set(true);
        try {
            await this.consentService.aceitar();
        } finally {
            this.processando.set(false);
        }
    }

    async recusar(): Promise<void> {
        if (this.processando()) return;

        this.processando.set(true);
        try {
            await this.consentService.recusar();
        } finally {
            this.processando.set(false);
        }
    }
}
